

import { GetFavourites, GetFavouritesResponse } from '@/api/dtos';
import { SWRConfiguration, SWRResponse } from 'swr';
import useGet from '../../api/useGet';

const getData = (response?: SWRResponse<GetFavouritesResponse, GetFavouritesResponse>) => response?.data?.favourites;
const getError = (response?: SWRResponse<GetFavouritesResponse, GetFavouritesResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useGetFavourites = (configuration?: SWRConfiguration | undefined) => {
    const request =  () => {
        return new GetFavourites();
    };
    // const client = useContext(ServiceStackClientContext);
    // return client.get(new GetFavourites());
    return useGet(request, { getData, getError }, configuration);
}

export default useGetFavourites;